import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { getQueryString, addRlog } from 'utils/util'
import { userStatus, personinfoExists } from 'servers/header'
import VolunteerModal from 'components/VolunteerModal'
import useStore from 'store'
import Modal from 'components/Modal'
import { getPersonInfo } from 'servers/percenter'
import s from './index.module.less'
import icon from './icon.png'
import PerCenterModal from '../PerCenterModal'

export const volunteerTypeList = [
  {
    id: 'collegesVolunteer',
    name: '智能填报'
  },
  {
    id: 'probabilityVolunteer',
    name: '录取概率测算'
  }
]

const PadBanner: React.FC<{ bannerName: string }> = ({ bannerName }) => {
  const history = useHistory()
  const { location } = history
  const { state, dispatch } = useStore()
  const port = getQueryString('port')
  // 编辑填报信息弹窗
  const [modalVisible, setModalVisible] = useState(false)
  const [tipsVisible, setTipsVisible] = useState(false)

  const toPage = (id = '') => {
    if (id === 'probabilityVolunteer') {
      addRlog('page_enter', {
        page_name: '录取概率测算'
      })
    }
    history.replace({
      pathname: `/${id}`,
      search: `?type=1&port=pad`
    })
  }

  const deleteQuery = () => {
    // 填志愿和录取概率测算由客户端带来的showEdit 刷新后需要去掉
    const { pathname } = location
    if (pathname.includes('Volunteer')) {
      history.replace({
        pathname: `${pathname}`,
        search: `?type=1&port=pad`
      })
    }
  }

  const goClinetBack = () => {
    // 查学校和做测评 未填写高考信息的时候，关闭弹窗是直接关闭弹窗，不回退路由
    if (
      state.showPersoninfoModel &&
      (location.pathname.includes('searchSchool') || location.pathname.includes('evaluationDetail'))
    ) {
      return dispatch({ type: 'updatePersoninfoModel', payload: false })
    }
    /* eslint-disable */
    // @ts-ignore
    return window?.ydk?._invoke('back')
  }

  const clickBanner = (item: { id: string; name: string }) => {
    const { id } = item
    toPage(id)
  }

  const back = () => {
    // 做测评过程中退出要提示
    if (location.pathname.includes('evaluationGround')) {
      setTipsVisible(true)
      return
    }
    goClinetBack()
  }

  useEffect(() => {
    // 获取个人信息
    if (!state.userInfo?.id) {
      userStatus().then((res) => {
        if (res.status === 200) {
          dispatch({ type: 'updateUserInfo', payload: res.data })
          dispatch({ type: 'updateMobileFromUrs', payload: res.data.mobile })
        }
      })
    } else {
      personinfoExists().then((res) => {
        dispatch({ type: 'updatePersoninfoExist', payload: res.data })
        // 根据路由判断是否展示填报弹窗
        if (getQueryString('showEdit') === 'double') {
          addRlog('dialog', {
            dialog_name: '二合一弹窗'
          })
          dispatch({ type: 'updatePersoninfoModel', payload: true })
        } else if (getQueryString('showEdit') === 'sigle') {
          addRlog('dialog', {
            dialog_name: '修改/维护高考信息弹窗'
          })
          setModalVisible(true)
        }
      })
    }
  }, [state.userInfo?.id, getQueryString('showEdit')])

  useEffect(() => {
    if (state.personinfoExist) {
      getPersonInfo().then((res) => {
        if (res.code === 0) dispatch({ type: 'updateUserInfo', payload: res.data })
      })
    }
  }, [state.personinfoExist])

  return (
    <>
      {port === 'pad' && (
        <>
          <div className={s.BannerBox}>
            <div className={s.bannerCenter}>
              <button type="button" onClick={back} className={s.backButton}>
                <img src={icon} alt="" />
              </button>
              {bannerName !== 'common' ? (
                <p className={s.sigle}>{bannerName}</p>
              ) : (
                <ul className={s.Banner}>
                  {volunteerTypeList.map((v) => (
                    <li
                      key={v.id}
                      className={`${location.pathname.includes(v.id) ? s.active : ''}`}
                    >
                      <button type="button" onClick={() => clickBanner(v)}>
                        {v.name}
                      </button>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
          {modalVisible && (
            <VolunteerModal
              visible={modalVisible}
              value={state.volunteerData}
              onCancel={() => {
                // 编辑的时候没填分数或者选科 关闭的时候直接退回到首页
                if (!state.volunteerData?.isSelectCourse || !state.volunteerData?.gkTotalScore)
                  goClinetBack()
                setModalVisible(false)
                deleteQuery()
              }}
            />
          )}
          <Modal
            title="您此次的作答记录将不会被保留，确认退出答题吗？"
            visible={tipsVisible}
            footer="okAndCancel"
            onOk={goClinetBack}
            onCancel={() => setTipsVisible(false)}
          />
          {state.showPersoninfoModel && (
            <PerCenterModal
              closeCb={() => {
                if (!state.volunteerData) goClinetBack()
              }}
              okCb={() => {
                // 在pad内二合一信息填写不完全在展示编辑弹窗
                if (!(state.volunteerData?.isSelectCourse && state.volunteerData.gkTotalScore))
                  setTimeout(() => setModalVisible(true), 300)
              }}
            />
          )}
        </>
      )}
    </>
  )
}

export default PadBanner
